import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import HelpIcon from "@mui/icons-material/Help";
import PersonIcon from "@mui/icons-material/Person";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Grid } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@mui/styles";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import AlertMessage from "../../../components/molecules/AlertMessage";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";
import {
  deletePengurus,
  getDetailPengurus,
  getDetailTableExcoPusat,
  patchPengurus,
  postPengurus,
} from "../../../config/Redux/ExcoDetailPusat/actions";
import {
  deleteDocumentPengurus,
  downloadDocumentPengurus,
  getAnggota,
  getJabatan,
  uploadDocumentPengurus,
  getCatatan,
} from "../../../config/Redux/Global/actions";
import { getBase64, PRIMARY } from "../../../utils/constansColors";
import { Gap, MyAutocomplete, MyButton, MyInput } from "../../atoms";
import MyDialog from "../../molecules/Dialog";

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: PRIMARY,
      color: "white",
      border: "none",
    },
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    borderRadius: 5,
  },
  tableHeader: {
    backgroundColor: "transparant",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    color: "#757575",
    fontWeight: 700,
  },
});

const validationSchema = yup.object().shape({
  jabatan: yup
    .object()
    .shape({
      label: yup.string(),
      id: yup.string(),
    })
    .nullable()
    .required("Silahkan Masukan Jabatan"),
  anggota: yup
    .object()
    .shape({
      label: yup.string(),
      id: yup.string(),
    })
    .nullable()
    .required("Silahkan Masukan Nama Anggota"),
  npwp: yup.string().nullable(),
  catatan: yup
    .object()
    .shape({
      label: yup.string(),
      id: yup.string(),
    })
    .nullable()
    .required("Silahkan Masukan Catatan"),
});

const columnData = [
  { no: 0, name: "No" },
  { no: 1, name: "Jabatan" },
  { no: 2, name: "Nama" },
  { no: 3, name: "No. Kartu Tanda Anggota" },
  { no: 4, name: "NIK" },
  // { no: 5, name: "Nomor Surat Keputusan" },
  // { no: 6, name: "Alamat Kantor Tetap" },
  { no: 8, name: "Jenis Kelamin" },
  { no: 7, name: "No Handphone" },
  // { no: 9, name: "NPWP" },
  // { no: 10, name: "Pernyataan Bukan Anggota Partai Politik Lain" },
  { no: 10, name: "Surat Pernyataan Kesediaan Menjadi Pengurus" },
  { no: 11, name: "Catatan" },
];

const DetailTable = (props) => {
  let params = useParams();
  const officeId = props.officeId || params?.officeId;
  const tingkatExcoId = props.tingkatExcoId || params?.tingkatExcoId;
  const hideAddButton = props.hideAddButton;

  const [openDelete, setOpenDelete] = React.useState(false);
  const [openDialogUser, setOpenDialogUser] = React.useState(false);
  const [idDelete, setIdDelete] = React.useState(null);
  const [idEdit, setIdEdit] = React.useState(null);
  const [action, setAction] = React.useState("add");
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [searchTerm, setSearchTerm] = React.useState("");
  const dispatch = useDispatch();
  const classes = useStyles();

  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDialogDelete, setOpenDialogDelete] = React.useState(false);
  const [documentView, setDocumentView] = React.useState(null);
  const [openView, setOpenView] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [fileError, setFileError] = React.useState("");
  const [selectPengurus, setSelectPengurus] = React.useState(null);
  const fileTypes = ["PDF"];
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
  const handleChange = (file) => {
    if (file && file.size > MAX_FILE_SIZE) {
      setFileError(
        "Ukuran file melebihi 2MB. Silakan pilih file yang lebih kecil.",
      );
      setFile(null);
      return;
    }
    setFileError("");
    setFile(file);
  };
  const handleCloseDragAndDrop = () => {
    setOpenDialog(false);
    setFile(null);
    setFileError("");
  };
  const handleOpenDragAndDrop = (param, id_pengurus) => {
    if (param === "openDialog") {
      // setFile(fileName);
      setOpenDialog(true);
      setSelectPengurus(id_pengurus);
    } else {
      setOpenDialog(false);
      setSelectPengurus(null);
    }
  };
  const handleselectedFiles = async (event) => {
    let base64 = await getBase64(event);
    let payload = {
      id_pengurus_exco: selectPengurus,
      file_name: event?.name?.slice(0, -4),
      dokumen: `${base64}`,
    };
    // setLoading(true);
    let resp = await dispatch(uploadDocumentPengurus(payload));
    if (resp.type === "UPLOAD_DOCUMENT_PENGURUS_SUCCESS") {
      dispatch(getDetailTableExcoPusat(officeId));
      // await dispatch(getExcoDocument(params?.officeId));
      // setFileNamePengurus(event.name);
      // setLoading(false);
      // setMessage(
      //   <div align="center">
      //     <p>SK Pengurus</p>
      //     {resp.payload.message}
      //   </div>
      // );
      setOpenDialogAlert(true);
      setStatus("");
    } else {
      // setLoading(false);
      setMessage(resp.payload.data.message);
      setOpenDialogAlert(true);
      setStatus("error");
    }
  };
  const handleOpenDragAndDropSave = () => {
    setOpenDialog(false);
    handleselectedFiles(file);
    setFile(null);
  };

  const handleOpenDelete = (value, id_pengurus) => {
    setOpenDialogDelete(value);
    setSelectPengurus(id_pengurus);
  };
  const handleDeleteFile = async () => {
    const resp = await dispatch(deleteDocumentPengurus(selectPengurus));
    if (resp.type === "DELETE_DOCUMENT_PENGURUS_SUCCESS") {
      setOpenDialogDelete(false);
      dispatch(getDetailTableExcoPusat(officeId));
      setSelectPengurus(null);
    }
  };
  const base64ToBlob = (base64, type = "application/octet-stream") => {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
  };
  const handleViewDoc = async (id) => {
    const resp = await dispatch(downloadDocumentPengurus(id));
    if (resp.type === "DOWNLOAD_DOCUMENT_PENGURUS_SUCCESS") {
      let data = await resp.payload.dokumen;
      let resultData = `${data}`;
      const blob = base64ToBlob(resultData, "application/pdf");
      const url = URL.createObjectURL(blob);
      setDocumentView(url);
      setOpenView(true);
    }
  };
  const handleCloseDialogView = () => {
    setOpenView(false);
  };
  const renderValueView = (
    <>
      <iframe
        title="pdfView"
        // src={"data:application/pdf;base64," + documentView}
        src={documentView}
        style={{ width: "100%", height: "80vh" }}
      ></iframe>
    </>
  );

  const handleDownloadDoc = async (id) => {
    // if(pa)
    const resp = await dispatch(downloadDocumentPengurus(id));

    if (resp.type === "DOWNLOAD_DOCUMENT_PENGURUS_SUCCESS") {
      let data = await resp.payload.dokumen;
      let resultData = `data:application/pdf;base64,${data}`;
      let a = document.createElement("a");
      a.href = resultData;
      a.download = resp.payload.file_name;
      a.click();
    }
  };

  const [loadingDownloadSurat, setLoadingDownloadSurat] = React.useState(false);

  const handleDownloadSuratPernyataan = async () => {
    setLoadingDownloadSurat(true);
    let fileUrl = "";
    let fileName = "";

    const tingkat = params?.tingkatExcoId;

    if (!tingkat || tingkat === "1" || tingkat === "2") {
      fileUrl = "/templates/PROVINSI_SURAT_PERNYATAAN_CALON_PENGURUS.docx";
      fileName = "PROVINSI_SURAT_PERNYATAAN_CALON_PENGURUS.docx";
    } else if (
      tingkat === "3" ||
      tingkat === "4" ||
      tingkat === "5" ||
      tingkat === "6" ||
      tingkat === "7"
    ) {
      // Kabkot, Kecamatan, RT/RW, Komisaris Basis/PUK semua pakai template Kabkot
      fileUrl = "/templates/KABKOT_SURAT_PERNYATAAN_CALON_PENGURUS.docx";
      fileName = "KABKOT_SURAT_PERNYATAAN_CALON_PENGURUS.docx";
    } else {
      console.warn("Tidak ada template untuk tingkat exco ini.");
      setLoadingDownloadSurat(false);
      return;
    }

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    link.click();

    // brief loading so user sees feedback
    setTimeout(() => {
      setLoadingDownloadSurat(false);
    }, 1500);
  };

  // alert message
  const [openDialogAlert, setOpenDialogAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [status, setStatus] = React.useState(null);

  // selector
  const dataTable = useSelector(
    (state) => state.excodetail.dataTableDetailExco,
  );

  // Get Lock Status from Props (Priority) or Fallback to Redux
  const dataExcoPusat = useSelector((state) => state.excopusat.dataExcoPusat);

  // Use props.isLocked if available, otherwise fallback to existing logic
  const isLocked =
    props.isLocked !== undefined
      ? parseInt(props.isLocked) === 1
      : parseInt(dataExcoPusat?.data?.data?.[0]?.is_locked) === 1;

  const dataJabatan = useSelector((state) => state.global.dataJabatan);
  const dataAnggota = useSelector((state) => state.global.dataAnggota);
  const dataCatatan = useSelector((state) => state.global.dataCatatan);
  const dataDetail = useSelector(
    (state) => state.excodetail.getDetailTablePengurus,
  );
  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  //cek hak akses
  const checkHakAkses = (list, akses) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
      return val;
    });
    return has;
  };

  // console.log("setai",dataDetailExco)

  const dataDetailExcoPusat = useSelector(
    (state) => state.excopusat.dataDetailExcoPusat,
  );
  let dataUser = dataDetail?.data;

  // options
  let optionsJabatan = dataJabatan?.data?.map((item) => ({
    label: item.nama_jabatan,
    id: item.id_jabatan,
  }));
  let optionsAnggota = dataAnggota?.data?.map((item) => ({
    label: item.name + " (" + item.noKta + " / " + item.nik + ")",
    id: item.nik,
  }));
  let optionsCatatan = dataCatatan?.data?.map((item) => ({
    label:
      item.catatan_name ||
      item.catatan ||
      item.name ||
      item.nama ||
      item.label ||
      item,
    id: item.catatan_id || item.id_catatan || item.id || item,
  })).filter((item) => {
    if (String(tingkatExcoId) !== "1") {
      return item.label?.toString().toUpperCase() !== "MAJELIS";
    }
    return true;
  });

  // console.log(dataAnggota)

  // handle delete user
  const handleCloseDialogDelete = () => {
    setOpenDelete(false);
    setIdDelete(null);
  };

  const handleDeleteUser = async () => {
    setIdDelete(null);
    let resp = await dispatch(deletePengurus(idDelete));
    if (resp.type === "DELETE_DETAIL_TABLE_EXCO_PUSAT_SUCCESS") {
      dispatch(getDetailTableExcoPusat(officeId));
      setOpenDialogAlert(true);
      setMessage(resp.payload.message);
      setStatus("");
      setOpenDelete(false);
    } else {
      setOpenDialogAlert(true);
      setMessage(resp.payload.data.message);
      setStatus("error");
      setOpenDelete(false);
    }
  };

  // handle add user
  const handleCloseDialogUser = () => {
    setOpenDialogUser(false);
  };

  // handle edit user
  const handleClickEdit = (id) => {
    setIdEdit(id);
    dispatch(getDetailPengurus(id));
    setAction("edit");
    setOpenDialogUser(true);
  };

  const handleSelectSearch = (event) => {
    dispatch(getAnggota(event.target.value));
  };

  // formik add/edit user
  const formikUser = useFormik({
    initialValues: {
      jabatan:
        action === "edit"
          ? {
            label: dataUser?.data_diri?.nama_jabatan,
            id: dataUser?.data_diri?.id_jabatan,
          }
          : null,
      anggota:
        action === "edit"
          ? {
            label: dataUser?.data_diri?.nama,
            id: dataUser?.data_diri?.nik,
          }
          : null,
      npwp: action === "edit" ? dataUser?.data_diri?.npwp : null,
      catatan:
        action === "edit" && dataUser?.data_diri?.catatan_id
          ? {
            label:
              dataUser?.data_diri?.catatan_name ||
              dataUser?.data_diri?.catatan,
            id: dataUser?.data_diri?.catatan_id,
          }
          : null,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // console.log(values)
      let payload = {
        id_jabatan: values.jabatan.id,
        id_kantor_exco: officeId,
        nik: values.anggota.id,
        npwp: values.npwp,
        catatan_id: values.catatan?.id,
      };

      let payloadEdit = {
        id_jabatan: values.jabatan.id,
        nik: values.anggota.id,
        npwp: values.npwp,
        catatan_id: values.catatan?.id,
      };

      if (action === "add") {
        let resp = await dispatch(postPengurus(payload));
        if (resp.type === "POST_DETAIL_TABLE_EXCO_PUSAT_SUCCESS") {
          handleCloseDialogUser();
          setOpenDialogAlert(true);
          setMessage(resp.payload.message);
          setStatus("");
          dispatch(getDetailTableExcoPusat(params?.officeId));
        } else {
          setOpenDialogAlert(true);
          setMessage(resp.payload.data.message);
          setStatus("error");
        }
      } else {
        let resp = await dispatch(patchPengurus(idEdit, payloadEdit));
        if (resp.type === "PATCH_DETAIL_TABLE_EXCO_PUSAT_SUCCESS") {
          handleCloseDialogUser();
          setOpenDialogAlert(true);
          setMessage(resp.payload.message);
          setStatus("");
          dispatch(getDetailTableExcoPusat(params?.officeId));
        } else {
          setOpenDialogAlert(true);
          setMessage(resp.payload.data.message);
          setStatus("error");
        }
      }
    },
  });
  // delete user
  const renderValueDelete = (
    <div align="center">
      <HelpIcon style={{ fontSize: 60, color: "#F06524" }} />
      <h3>Perhatian!</h3>
      <p>Yakin Untuk Menghapus ?</p>
      <Gap height={20} />
      <div align="center" style={{ display: "flex", justifyContent: "center" }}>
        <MyButton
          component="span"
          color="black"
          backgroundColor="white"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Batal"
          borderColor="#F06524"
          onClick={handleCloseDialogDelete}
          style={{ width: "100%" }}
        />
        <Gap width={10} />
        <MyButton
          component="span"
          color="#FFFFFF"
          backgroundColor="#F06524"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Hapus"
          borderColor="#F06524"
          style={{ width: "100%" }}
          onClick={handleDeleteUser}
        />
      </div>
    </div>
  );

  // form add data
  const renderFormUser = (
    <>
      <div style={{ display: "flex" }}>
        <span style={{ marginTop: 17 }}>
          <PersonIcon style={{ color: "#F06524", fontSize: 30 }} />
        </span>
        <h2>
          <b>{action === "edit" ? "Edit" : "Tambah"} Pengurus</b>
        </h2>
      </div>
      <Gap height={20} />
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <MyAutocomplete
            options={optionsAnggota}
            fullWidth
            size="medium"
            label="Nama Anggota (No KTA / NIK)*"
            id="anggota"
            name="anggota"
            value={formikUser.values.anggota}
            onKeyUp={(e) => {
              handleSelectSearch(e);
            }}
            onChange={(e, value) => {
              formikUser.setFieldValue("anggota", value);
            }}
          />
          <FormHelperText id="component-error-text" style={{ color: "red" }}>
            {formikUser.touched.anggota && formikUser.errors.anggota}
          </FormHelperText>
          {/* <FormHelperText id="component-error-text" style={{ color: "grey" }}>
            Masukkan nama / NIK / no. KTA
          </FormHelperText> */}
        </Grid>

        <Grid item xs={12} md={6}>
          <MyAutocomplete
            options={optionsJabatan}
            fullWidth
            size="medium"
            label="Jabatan*"
            id="jabatan"
            name="jabatan"
            value={formikUser.values.jabatan}
            onChange={(e, value) => {
              formikUser.setFieldValue("jabatan", value);
            }}
          />
          <FormHelperText id="component-error-text" style={{ color: "red" }}>
            {formikUser.touched.jabatan && formikUser.errors.jabatan}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={6}>
          <MyAutocomplete
            options={optionsCatatan || []}
            fullWidth
            size="medium"
            label="Catatan*"
            id="catatan"
            name="catatan"
            value={formikUser.values.catatan}
            onChange={(e, value) => {
              formikUser.setFieldValue("catatan", value);
            }}
          />
          <FormHelperText id="component-error-text" style={{ color: "red" }}>
            {formikUser.touched.catatan && formikUser.errors.catatan}
          </FormHelperText>
        </Grid>

        {/* <Grid item xs={12} md={6}>
          <MyInput
            id="npwp"
            name="npwp"
            label="NPWP*"
            fullWidth
            size="medium"
            value={formikUser.values.npwp}
            onChange={formikUser.handleChange}
            error={formikUser.touched.npwp && Boolean(formikUser.errors.npwp)}
            helperText={formikUser.touched.npwp && formikUser.errors.npwp}
          />
        </Grid> */}
      </Grid>

      <Gap height={30} />

      <div style={{ display: "flex" }}>
        <MyButton
          height="40px"
          color="#B9B9B9"
          fullWidth
          backgroundColor="#FFFFFFFF"
          borderColor="#B9B9B9"
          backgroundColorHover="#FFFFFFFF"
          variant="outlined"
          children="Batal"
          onClick={handleCloseDialogUser}
        />
        <Gap width={30} />
        <MyButton
          height="40px"
          color="#8B8B8B"
          colorHover="white"
          fullWidth
          backgroundColor="#E8E8E8"
          borderColor="#E8E8E8"
          backgroundColorHover="#F06524"
          variant="outlined"
          children="Simpan"
          type="submit"
          onClick={formikUser.handleSubmit}
        />
      </div>
    </>
  );

  useEffect(() => {
    let shouldFetch = true;
    if (dataTable?.data && dataTable?.data.length > 0) {
      if (String(dataTable?.data[0]?.id_kantor_exco) === String(officeId)) {
        shouldFetch = false;
      }
    }

    if (officeId && shouldFetch) {
      dispatch(getDetailTableExcoPusat(officeId));
    }
    if (String(tingkatExcoId) === "1") {
      dispatch(getJabatan("1"));
    } else {
      dispatch(getJabatan(tingkatExcoId || "1"));
    }
    dispatch(getAnggota(""));
    dispatch(getCatatan());
  }, [dispatch, params, officeId]);

  const handleSort = (data) => {
    data?.data?.sort((a, b) => {
      const orderA = a.data_diri?.order_jabatan ?? a.data_diri?.id_jabatan;
      const orderB = b.data_diri?.order_jabatan ?? b.data_diri?.id_jabatan;
      return orderA - orderB;
    });
    return data;
  };

  const renderWomenStatus = (data) => {
    // 1 3 5 7 9 10
    let harianData = data?.filter((list) => list?.data_diri?.catatan_id === 2 || list?.data_diri?.catatan_name?.toUpperCase() === "HARIAN") || [];
    let countPengurus = harianData.length;
    let countWomen = 0;
    let complete = 0;
    harianData.map((list) => {
      if (list?.data_diri?.jenis_kelamin === "Perempuan") {
        countWomen++;
      }
      if (
        list?.data_diri?.id_jabatan === 1 ||
        list?.data_diri?.id_jabatan === 7
      ) {
        complete++;
      }
      if (
        list?.data_diri?.id_jabatan === 3 ||
        list?.data_diri?.id_jabatan === 9
      ) {
        complete++;
      }
      if (
        list?.data_diri?.id_jabatan === 5 ||
        list?.data_diri?.id_jabatan === 10
      ) {
        complete++;
      }
      return list;
    });
    let percentage = 0;
    if (countPengurus || countPengurus > 0 || countWomen > 0) {
      percentage = (countWomen * 100) / countPengurus;
    }
    let status = "BELUM";
    if (percentage >= 30) {
      status = "SUDAH";
    }
    let pengurusTerdaftar = "";
    if (complete < 3) {
      if (countPengurus < 3) {
        pengurusTerdaftar = complete + "/3";
      } else {
        pengurusTerdaftar = countPengurus - 3 + complete + "/" + countPengurus;
      }
    } else {
      pengurusTerdaftar = countPengurus + "/" + countPengurus;
    }

    return (
      <div style={{ marginTop: 20, fontSize: 14 }}>
        <p>
          Total pengurus harian <b>{countPengurus}</b>, total pengurus harian perempuan{" "}
          <b>
            {countWomen}/{countPengurus} ({percentage.toFixed(2)}%)
          </b>
        </p>
        <p>
          Anda <b>{status}</b> memenuhi syarat jumlah pengurus perempuan sebesar
          lebih dari atau sama dengan 30%
        </p>
      </div>
    );
  };

  const renderValue = (
    <div style={{ padding: 10 }}>
      {/* <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 20 }}>Unggah Surat Pernyataan Pengurus</h3> */}
      <div style={{ marginBottom: 20 }}>
        <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>
          Unggah Surat Pernyataan
        </p>
        <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>Pengurus</p>
      </div>

      <div
        style={{
          border: "2px dashed #E0E0E0",
          borderRadius: 8,
          backgroundColor: "#FAFAFA",
          cursor: "pointer",
          marginBottom: 10,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <FileUploader
          handleChange={handleChange}
          name="file"
          types={fileTypes}
          // label="Klik atau drop file disini"
          children={
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                padding: "10px",
                minHeight: "100px",
              }}
            >
              <div
                style={{
                  marginRight: "12px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <UploadFileIcon style={{ color: "#F06524", fontSize: 28 }} />
              </div>
              <div style={{ textAlign: "left" }}>
                <p
                  style={{
                    margin: "0 0 2px",
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#424242",
                  }}
                >
                  Klik atau drop file disini
                </p>
                <p style={{ margin: 0, fontSize: 12, color: "#9E9E9E" }}>
                  format file PDF (maks. 2MB)
                </p>
              </div>
            </div>
          }
        />
      </div>

      {fileError && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            backgroundColor: "#FFF3F3",
            border: "1px solid #F44336",
            borderRadius: 6,
            padding: "10px 14px",
            marginTop: 8,
          }}
        >
          <span style={{ fontSize: 22 }}>⚠️</span>
          <div>
            <p
              style={{
                margin: 0,
                fontSize: 14,
                fontWeight: 700,
                color: "#D32F2F",
              }}
            >
              File terlalu besar!
            </p>
            <p
              style={{
                margin: "2px 0 0",
                fontSize: 13,
                color: "#D32F2F",
              }}
            >
              Maksimal ukuran file adalah 2MB. Silakan kompres atau pilih file
              lain.
            </p>
          </div>
        </div>
      )}
      <p style={{ margin: "5px 0 20px", fontSize: 13, color: "#757575" }}>
        {file ? `File: ${file.name}` : "No file uploaded yet"}
      </p>

      <div style={{ display: "flex", gap: 16 }}>
        <MyButton
          color="black"
          backgroundColor="white"
          backgroundColorHover="#fafafa"
          variant="outlined"
          children="Batal"
          height="44px"
          style={{
            width: "50%",
            fontWeight: 600,
            border: "1px solid #E0E0E0",
            borderRadius: 6,
          }}
          onClick={handleCloseDragAndDrop}
        />
        <MyButton
          color="#FFFFFF"
          height="44px"
          backgroundColor={file ? "#F06524" : "#E0E0E0"}
          backgroundColorHover={file ? "#d6551b" : "#E0E0E0"}
          variant="contained"
          children="Unggah"
          disabled={!file}
          style={{
            width: "50%",
            fontWeight: 600,
            borderRadius: 6,
            boxShadow: "none",
          }}
          onClick={handleOpenDragAndDropSave}
        />
      </div>
    </div>
  );

  const renderValueDeleteDoc = (
    <div align="center">
      <HelpIcon style={{ fontSize: 60, color: "#F06524" }} />
      <h3>Perhatian!</h3>
      <p>Yakin Untuk Menghapus ?</p>
      <Gap height={20} />
      <div align="center" style={{ display: "flex", justifyContent: "center" }}>
        <MyButton
          component="span"
          color="black"
          backgroundColor="white"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Batal"
          borderColor="#F06524"
          onClick={() => handleOpenDelete(false, null)}
          style={{ width: "100%" }}
        />
        <Gap width={10} />
        <MyButton
          component="span"
          color="#FFFFFF"
          backgroundColor="#F06524"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Hapus"
          borderColor="#F06524"
          style={{ width: "100%" }}
          onClick={handleDeleteFile}
        />
      </div>
    </div>
  );

  return (
    <div>
      {/* delete file */}
      <MyDialog
        openDialog={openDelete}
        handleCloseDialog={handleCloseDialogDelete}
        renderValue={renderValueDelete}
      />

      {/* add new user */}
      <MyDialog
        openDialog={openDialogUser}
        handleCloseDialog={handleCloseDialogUser}
        renderValue={renderFormUser}
        fullWidth={true}
        maxWidth={"sm"}
      />

      {/* alertMessage */}
      <AlertMessage
        openDialog={openDialogAlert}
        message={message}
        status={status}
        handleCloseDialog={() => setOpenDialogAlert(false)}
      />

      {/* delete file */}
      <MyDialog
        openDialog={openDialogDelete}
        handleCloseDialog={() => handleOpenDelete(false, null)}
        renderValue={renderValueDeleteDoc}
      />

      <MyDialog
        openDialog={openDialog}
        handleCloseDialog={handleOpenDragAndDrop}
        renderValue={renderValue}
        fullWidth={true}
        maxWidth={"sm"}
      />

      {/* view file pdf */}
      <MyDialog
        openDialog={openView}
        handleCloseDialog={handleCloseDialogView}
        renderValue={renderValueView}
        fullWidth={true}
        maxWidth={"medium"}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        {/* Search Bar */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="text"
            placeholder="Search by nama"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setPage(1); // Reset to page 1 on search
            }}
            style={{
              padding: "10px 16px",
              borderRadius: "4px 0 0 4px",
              border: "1px solid #e0e0e0",
              borderRight: "none",
              outline: "none",
              width: 250,
              fontSize: 14,
            }}
          />
          <div
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #e0e0e0",
              borderRadius: "0 4px 4px 0",
              padding: "8px 12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                stroke="#757575"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21 21L16.65 16.65"
                stroke="#757575"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ display: "flex", gap: 10 }}>
          <MyButton
            onClick={handleDownloadSuratPernyataan}
            color="#333"
            backgroundColor="white"
            borderColor="#e0e0e0"
            variant="outlined"
            disabled={loadingDownloadSurat}
            children={
              loadingDownloadSurat ? (
                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <CircularProgress size={16} style={{ color: "#F06524" }} />
                  Mengunduh...
                </span>
              ) : (
                "Unduh Contoh Surat"
              )
            }
            style={{ fontWeight: 600, textTransform: "none", borderRadius: 4 }}
          />

          {!hideAddButton &&
            !isLocked &&
            (checkHakAkses(profile?.data?.hak_akses, "Document Admin Access") ||
              checkHakAkses(
                profile?.data?.hak_akses,
                "Document Manager Access",
              )) ? (
            <MyButton
              startIcon={<AddIcon />}
              style={{ height: 40 }}
              color="white"
              backgroundColor="#F06524"
              borderColor="#F06524"
              backgroundColorHover="#F06524"
              variant="outlined"
              children="Tambah Pengurus"
              onClick={() => {
                setOpenDialogUser(true);
                setAction("add");
                formikUser.resetForm();
              }}
            />
          ) : null}
        </div>
      </div>
      <TableContainer>
        <Table
          sx={{ minWidth: 650 }}
          aria-label="simple table"
          className={classes.tableHeader}
        >
          <TableHead style={{ backgroundColor: "#F9F9F9" }}>
            <TableRow>
              {columnData.map((item, key) => {
                if (params?.tingkatExcoId === "1" && item.no === 5) {
                  return null;
                } else if (params?.tingkatExcoId === "4" && item.no === 6) {
                  return null;
                } else {
                  return (
                    <TableCell
                      key={key}
                      style={{
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#757575",
                        padding: "16px 8px",
                        borderBottom: "1px solid #eee",
                        width: item.name === "No" ? "5%" : "",
                      }}
                    >
                      {item.name}
                    </TableCell>
                  );
                }
              })}
              <TableCell
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  color: "#757575",
                  width: "5%",
                  padding: "16px 8px",
                  borderBottom: "1px solid #eee",
                }}
              >
                Aksi
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
        {dataTable?.data?.length ? (
          ""
        ) : (
          <div style={{ textAlign: "center", color: "#bdbdbd" }}>
            <p>Belum Ada Pengurus</p>
          </div>
        )}
        <div
          style={{
            maxHeight: "400px",
            minWidth: "650px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {
            // Loading State
            dataTable?.loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "40px 0",
                }}
              >
                <CircularProgress style={{ color: "#F06524" }} />
              </div>
            ) : (
              // Data Map
              handleSort(dataTable)
                ?.data?.filter((item) => {
                  if (!searchTerm) return true;
                  return item?.data_diri?.nama
                    ?.toLowerCase()
                    .includes(searchTerm.toLowerCase());
                })
                ?.slice((page - 1) * rowsPerPage, page * rowsPerPage)
                ?.map((item, index) => {
                  let number = (page - 1) * rowsPerPage + index + 1;
                  return (
                    <Table
                      sx={{ minWidth: 650 }}
                      aria-label="simple table"
                      className={classes.tableBody}
                      key={"tab-" + index}
                    >
                      <TableBody>
                        <TableRow key={item.id}>
                          <TableCell
                            style={{
                              width: "5%",
                              padding: "12px 8px",
                              fontSize: "14px",
                            }}
                          >
                            {number}
                          </TableCell>
                          <TableCell
                            style={{ padding: "12px 8px", fontSize: "14px" }}
                          >
                            {item?.data_diri?.nama_jabatan}
                          </TableCell>
                          <TableCell
                            style={{ padding: "12px 8px", fontSize: "14px" }}
                          >
                            {item?.data_diri?.nama}
                          </TableCell>
                          <TableCell
                            style={{ padding: "12px 8px", fontSize: "14px" }}
                          >
                            <div style={{ wordWrap: "break-word" }}>
                              {item?.data_diri?.no_kta}
                            </div>
                          </TableCell>

                          <TableCell
                            style={{ padding: "12px 8px", fontSize: "14px" }}
                          >
                            <div style={{ wordWrap: "break-word" }}>
                              {item?.data_diri?.nik}
                            </div>
                          </TableCell>
                          <TableCell
                            style={{ padding: "12px 8px", fontSize: "14px" }}
                          >
                            <div style={{ wordWrap: "break-word" }}>
                              {item?.data_diri?.jenis_kelamin}
                            </div>
                          </TableCell>
                          <TableCell
                            style={{ padding: "12px 8px", fontSize: "14px" }}
                          >
                            <div style={{ wordWrap: "break-word" }}>
                              {item?.data_diri?.no_handphone}
                            </div>
                          </TableCell>
                          <TableCell
                            style={{ padding: "8px", textAlign: "center" }}
                          >
                            {item?.data_diri?.status_doc ? (
                              <div>
                                <div
                                  style={{
                                    margin: "4px",
                                    color: "green",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    borderBottom: "1px green solid",
                                  }}
                                >
                                  Telah Terunggah
                                </div>
                                <VisibilityIcon
                                  style={{ cursor: "pointer", margin: "3px" }}
                                  onClick={() =>
                                    handleViewDoc(item?.id_pengurus_exco)
                                  }
                                />
                                <DownloadIcon
                                  style={{ cursor: "pointer", margin: "3px" }}
                                  onClick={() =>
                                    handleDownloadDoc(item?.id_pengurus_exco)
                                  }
                                />
                                {!isLocked && (
                                  <DeleteOutlineIcon
                                    style={{
                                      cursor: "pointer",
                                      margin: "3px",
                                      color: "#D32F2F",
                                    }}
                                    onClick={() =>
                                      handleOpenDelete(
                                        true,
                                        item?.id_pengurus_exco,
                                      )
                                    }
                                  />
                                )}
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 4,
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "#FFEBEE",
                                    color: "#D32F2F",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                    padding: "4px 8px",
                                    borderRadius: "4px",
                                    display: "inline-block",
                                  }}
                                >
                                  Belum Terunggah
                                </div>

                                {!isLocked && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      color: "#03A9F4",
                                    }}
                                    onClick={() =>
                                      handleOpenDragAndDrop(
                                        "openDialog",
                                        item?.id_pengurus_exco,
                                      )
                                    }
                                  >
                                    <FileUploadIcon
                                      style={{ fontSize: 16, marginRight: 4 }}
                                    />
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Unggah
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </TableCell>
                          {/* <TableCell style={{ padding: "8px" }}>
                      <div style={{ wordWrap: "break-word" }}>
                        {item?.data_diri?.npwp}
                      </div>
                    </TableCell> */}
                          <TableCell
                            style={{ padding: "12px 8px", fontSize: "14px" }}
                          >
                            <div style={{ wordWrap: "break-word" }}>
                              {item?.data_diri?.catatan_name || "-"}
                            </div>
                          </TableCell>
                          <TableCell
                            style={{
                              width: "5%",
                              padding: "16px 8px",
                              textAlign: "center",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            {!isLocked &&
                              (checkHakAkses(
                                profile?.data?.hak_akses,
                                "Document Admin Access",
                              ) ||
                                checkHakAkses(
                                  profile?.data?.hak_akses,
                                  "Document Manager Access",
                                )) ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: 8,
                                }}
                              >
                                <EditOutlinedIcon
                                  style={{
                                    color: "#9E9E9E",
                                    cursor: "pointer",
                                    fontSize: 20,
                                  }}
                                  onClick={() =>
                                    handleClickEdit(item?.id_pengurus_exco)
                                  }
                                />
                                <DeleteOutlineIcon
                                  style={{
                                    color: "#F44336",
                                    cursor: "pointer",
                                    fontSize: 20,
                                  }}
                                  onClick={() => {
                                    setIdDelete(item?.id_pengurus_exco);
                                    setOpenDelete(true);
                                  }}
                                />
                              </div>
                            ) : null}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  );
                })
            )
          }
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px 0",
          }}
        >
          <Pagination
            count={Math.ceil(
              (handleSort(dataTable)?.data?.filter((item) => {
                if (!searchTerm) return true;
                return item?.data_diri?.nama
                  ?.toLowerCase()
                  .includes(searchTerm.toLowerCase());
              })?.length || 0) / rowsPerPage,
            )}
            page={page}
            onChange={(e, v) => setPage(v)}
            variant="outlined"
            shape="rounded"
            color="primary"
            renderItem={(item) => (
              <PaginationItem
                {...item}
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "#F06524",
                    color: "white",
                    border: "none",
                    "&:hover": {
                      backgroundColor: "#d6551b",
                    },
                  },
                }}
              />
            )}
          />
        </div>
        {renderWomenStatus(dataTable?.data)}
        <Gap height={50} />
      </TableContainer>
    </div>
  );
};

export default DetailTable;
